module.exports = __webpack_public_path__ + "static/media/edit_note.c358f23e.svg";